import React, { useState, useEffect, useContext, useCallback } from "react";
import moment from 'moment';
import { Button, Table, notification, Input, DatePicker, Select } from "antd";
import { SearchOutlined} from "@ant-design/icons";
import axios from "axios";
import GlobalContext from "../utils/GlobalContext";
import { v4 as uuidv4 } from "uuid";
import LoadingModal from "../utils/LoadingModal";

const PAGE_SIZE = 15;
const { RangePicker } = DatePicker;
const { Option } = Select;

const LogTable = () => {
  const globals = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
  });
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState("");
  const [action, setAction] = useState("");

  const columns = [
    {
      title: "Fecha y hora",
      dataIndex: "datePlanned",
      key: "datePlanned",
      render: (_, record) => {
        if (record.timestamp !== null)
          return (
            moment(record.timestamp).format("DD-MMM-YYYY HH:mm:ss")
          )
        else
          return (
            <p>Sin fecha</p>
          )
      }
    },
    {
      title: "Usuario",
      dataIndex: "user",
      key: "user",
    },
    {
      title: "Tipo de acción",
      dataIndex: "action",
      key: "department",
      width: "90px",
      render: (_, record) => {
        if (record.action == 1){
          return (
            <p>CREAR</p>
          )
        }
        else if (record.action == 2){
          return (
            <p>EDITAR</p>
          )
        }
        else if (record.action == 3){
          return (
            <p>ELIMINAR</p>
          )
        }
      }
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      width: "30%",
    },
    
  ];

  const fetchData = useCallback(
    async (newPagination, search, action, startDate, endDate) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        let params = {
            page,
            limit: pageSize,
            search: search,
            action: action,
            dateInit: (startDate) ? moment(startDate).format("YYYY-MM-DD") : null,
            dateEnd: (endDate) ? moment(endDate).format("YYYY-MM-DD") : null,
          }
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/consult-logs`,
          {
            headers: {
              "x-token": globals.token,
            },
            params,
          }
        );
        if (response.data.status !== 0){
          setLoading(false);
          return;
        }
        console.log("Data****-----:", response?.data);
        setData(response?.data?.data?.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data?.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data?.count,
          }
          );
        }
        notification.success({
          message: "Información obtenida exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.log("Error fetching data:", error.response);
        if (error?.response?.data?.status !== -3) {
          console.error("Error fetching data:", error.response);
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
            duration: 2,
          });
        }
        else{
          notification.warning({
            message: "No hay reuniones disponibles!",
            placement: "bottomRight",
            duration: 2,
          });
        
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  useEffect(() => {
    fetchData(null, null, null, null, null);
  }, [fetchData]);

  async function handleTableChange(newPagination) {
    fetchData(newPagination, searchText, action, dateRange?.start, dateRange?.end);
  }

  const handleRefresh = () => {
    fetchData(null, searchText, action, dateRange?.start, dateRange?.end);
  };

  const handleSearch = async () => {
    fetchData(null, searchText, action, dateRange?.start, dateRange?.end);
  };

  const handleSearchEnterKey = async (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
 
  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <h2 style={{ marginRight: "16px" }}>Registros de auditoría</h2>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        <Button
          onClick={handleRefresh}
          disabled={loading}
          style={{ marginRight: "8px" }}
        >
          Refrescar
        </Button>
      </div>
      <Input
        style={{ marginBottom: 16, width: 200, marginRight: 8 }}
        placeholder="Buscar"
        allowClear
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        prefix={<SearchOutlined />}
        onKeyDown={handleSearchEnterKey}
      />
      <Select 
        style={{ marginBottom: 16, width: 200, marginRight: 8 }}
        placeholder="Tipo de acción"
        allowClear
        value={action}
        onChange={(value) => setAction(value)}
      >
        <Option value={1}>CREAR</Option>
        <Option value={2}>EDITAR</Option>
        <Option value={3}>ELIMINAR</Option>
      </Select>
      <RangePicker
        style={{ marginBottom: 16, width: 200, marginRight: 8 }}
        onChange={(date, dateString) => {
          if (dateString[0] === "" || dateString[0] === null) {
            setDateRange("");
          }
          else{
            const startTimestamp = new Date(`${dateString[0]}T00:00:00Z`).getTime();
            const endTimestamp = new Date(`${dateString[1]}T23:59:59Z`).getTime();
            setDateRange({start: startTimestamp, end: endTimestamp});
          }
        }}
      />

      <Button onClick={handleSearch} style={{ marginRight: "8px" }}>
        Buscar
      </Button>
      <div
        className="site-layout-background h-auto"
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          margin: 0,
          height: "auto",
          minHeight: "350px",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <Table
          rowKey={(r) => uuidv4()}
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      </div>
      <LoadingModal open={loading} />
    </div>
  );
};

export default LogTable;
